import { LineBeaconServiceType } from './LineBeacon';

export enum BeaconType {
  LINE_SIMPLE_BEACON = 'LINE_SIMPLE_BEACON',
  TENMAX_BEACON = 'TENMAX_BEACON'
}

export type TenMaxLineBeaconConnection = {
  id: number;
  name: string;
  beaconType: BeaconType.LINE_SIMPLE_BEACON;
  webhookType: LineBeaconServiceType.TENMAX;
  hardwareId: string;
  channelSecret: string;
  channelAccessToken: string;
};

export type SelfServeLineBeaconConnection = OverrideAndNeverOthers<
  TenMaxLineBeaconConnection,
  {
    id: number;
    name: string;
    beaconType: BeaconType.LINE_SIMPLE_BEACON;
    webhookType: LineBeaconServiceType.SELF_SERVE;
    hardwareId: string;
  }
>;

export type TenMaxBeaconConnection = OverrideAndNeverOthers<
  TenMaxLineBeaconConnection,
  {
    id: number;
    name: string;
    beaconType: BeaconType.TENMAX_BEACON;
  }
>;

export type BeaconConnection =
  | TenMaxLineBeaconConnection
  | SelfServeLineBeaconConnection
  | TenMaxBeaconConnection;

export type LineBeaconConnectionFormData = {
  name: string;
  beaconType: BeaconType;
  webhookType: LineBeaconServiceType | '';
  hardwareId: string;
  channelSecret?: string;
  channelAccessToken?: string;
};

export type TenMaxBeaconConnectionFormData = OverrideAndNeverOthers<
  LineBeaconConnectionFormData,
  {
    name: string;
    beaconType: BeaconType;
  }
>;

export type BeaconConnectionFormData =
  | LineBeaconConnectionFormData
  | TenMaxBeaconConnectionFormData;

export type BeaconConnectionItem = {
  label: string;
  value: number;
  beaconType: BeaconType;
};

export type LineBotInfo = {
  userId: string;
  basicId: string;
  displayName: string;
  pictureUrl: string;
  chatMode: string;
  markAsReadMode: string;
};
